import { Route, RouteGroup } from '@billow/easy-route'
import { concat } from 'lodash'

export default concat(

  RouteGroup({
    
    middleware: ['auth', 'active-subscriber'],

    routes: [
      Route('/environments', 'environments', () => import('@/views/environments/Index.vue')),
    ]
  }),

  RouteGroup({

    middleware: ['auth', 'active-subscriber'],

    parent: Route('/environments/:environment', '', () => import('@/views/environments/manager/Index.vue')),

    routes: [
      Route('/', 'environment-manager', () => import('@/views/environments/manager/Overview.vue')),
      Route('events', 'environment-events', () => import('@/views/environments/manager/Events.vue')),
      Route('edit', 'environment-edit', () => import('@/views/environments/manager/Edit.vue')),

      // Routing
      Route('routes', 'environment-routes', () => import('@/views/environments/manager/Routes.vue')),
      Route('routes/:route', 'route-manager', () => import('@/views/route/Manager.vue')),

      // Attributes
      Route('attributes', 'environment-attributes', () => import('@/views/environments/manager/Attributes.vue')),
      Route('attributes/:attribute', 'attribute-manager', () => import('@/views/attribute/Common.vue')),
      Route('source/:attribute', 'source-manager', () => import('@/views/attribute/Source.vue')),

      // Software
      Route('software', 'environment-software', () => import('@/views/environments/manager/Software.vue')),
      Route('software/:software', 'software-manager', () => import('@/views/software/Manager.vue')),
      
      // Middleware
      Route('middleware', 'environment-middleware', () => import('@/views/environments/manager/Middleware.vue')),
      Route('middleware/:middleware', 'middleware-manager', () => import('@/views/middleware/Manager.vue')),
    ]
  })
)